module.exports = __webpack_public_path__ + "static/media/hard_difficulty.38f09c8d.png";